import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import fileFormats from 'config/constants/fileFormats';
import Modal from 'components/base/Modal';
import Button, { ButtonImport } from 'components/base/Button';

import { selectContactAssignableGroups, importContacts, selectLoading } from 'data/contacts';
import { getPopupRegistration, openPopup, closePopup } from 'app/PopupHolder';
import AddToMarketingListModal from '../../components/AddToMarketingListModal';
import importContactImg from 'assets/images/import-contacts-img.svg';

import css from './style.scss';
import csv from './contacts.csv';
import xls from './contacts.xls';
import xlsx from './contacts.xlsx';
import classNames from 'classnames';


class ContactImport extends PureComponent {
  constructor(props) {
    super(props);

    this.handleSave = this.handleSave.bind(this);
    this.handleSaveToGroup = this.handleSaveToGroup.bind(this);
    this.handleFileContact = this.handleFileContact.bind(this);

    this.state = { file: null };
  }

  handleSave() {
    const { importContacts, closePopup } = this.props;
    importContacts(this.state.file, null, closePopup);
  }

  handleSaveToGroup() {
    const { importContacts, closePopup, openAddToGroup, groups, loading } = this.props;
    openAddToGroup({
      groups,
      contactImportMode: true,
      hideSkipTraceOption: true,
      loading: loading,
      title: "Add to Group",
      closePopup: closePopup,
      onSave: (name, afterSuccess) => importContacts(this.state.file, name, ({ response, ...rest }) => {
        afterSuccess((response.find(c => c.modified) || {}).affected || 0)
        closePopup();
      }),
    });
  }

  handleFileContact(ev) {
    const file = ev.target.files[0];
    if (file.type === 'text/csv') {

      this.handleUpdateFileContact(file)
    } else {
      this.setState({ file });
    }

  }

  handleUpdateFileContact = (file) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      const contents = event.target.result;
      const parsedOldFile = contents.split('\n').map(row => row.split(','));
      const updatedContent = this.updateCellValueContact([...parsedOldFile]);
      const updatedFileContent = updatedContent.map(row => row.join(',')).join('\n');
      const updatedBlob = new Blob([updatedFileContent], { type: file.type });
      const updatedFile = new File([updatedBlob], file.name, { type: file.type });
      this.setState({ file: updatedFile });
    };
    reader.readAsText(file);
  }

  updateCellValueContact = (parsedOldFile) => {
    const dangerousChars = ['=', '+', '-', '@', '\t', '\r'];
    const updatedFile = parsedOldFile.map((row, index) => {
      return row.map(cell => {
        let trimmedValue = cell.replace(/^"(.*)"$/, '$1');
        const startsWithDangerousChars = dangerousChars.some(char => trimmedValue.startsWith(char));
        if (startsWithDangerousChars) {
          trimmedValue = `'${trimmedValue}`
          // Escape double quotes within the cell value
          trimmedValue = `""${trimmedValue}""`;
          // Wrap the cell value in double quotes
          return `"${trimmedValue}"`;

        } else {
          return `"${trimmedValue}"`;
        }
      });
    });
    return updatedFile;
  };

  render() {
    const { loading, closePopup } = this.props;
    const { file } = this.state;
    const btn = { size: Button.size.large, className: css.button, isLoading: loading };
    const accept = fileFormats.tables.map(format => `.${format}`).join(',');

    return (
      <Modal
        isOpen
        uniqId="ImportContacts"
        // width="calc(100% - 225px)"
        // height="100%"
        width="784px"
        border="0"
        padding="32px"
        className={css.root}
        caption="Import Contacts"
        isCloseButton
        closeBtnStyle={{ top: '30px', right: '26px',}}
      >
        <div className={css.upload}>
            <div>
              <img className={css.importPropertyImg} src={importContactImg} alt="importContactImg" />
            </div>
        {file ? (
          <div className={css.importContainer}>
            <div className={css.title} style={{textAlign:'center'}}>File Uploaded Successfully!</div>
            <div className={css.uplodedFileText}>Select ‘Import’ below or select ‘Remove’ to upload a different file.</div>
            <div className={css.fileName}>{file.name}</div>
            <button className={css.removeButton} onClick={() => this.setState({ file: null })}>Remove</button>
          </div>
        ) : (
            <div className={css.importContainer}>
              <div className={css.title}>To Import Your Existing Contacts:</div>
              <div className={css.stepText} style={{paddingTop: '16px'}}>
                <span className={css.stepNumber}>1.</span>
                <span className={css.stepContent}>
                  Download and use one of the following sample templates:&#160;
                  <a href={csv} download>.csv</a>, <a href={xls} download>.xls</a>, <a href={xlsx} download>.xlsx</a>.
                </span>
              </div>

              <div className={css.stepText}>
                <span className={css.stepNumber}>2.</span>
                <span className={css.stepContent}>
                  Enter your existing Contacts into the template using the example provided.
                </span>
              </div>

              <div className={css.stepText}>
                <span className={css.stepNumber}>3.</span>
                <span className={css.stepContent}>
                  Click the Choose File button to upload your saved template.
                </span>
              </div>

              <div className={css.buttons}>
                <a href={csv} download>
                  <button className={css.btnSecondary}>Download Template</button>
                </a>
                <ButtonImport className={classNames (css.btnPrimary, css.chooseFilebtn)} accept={accept} onChange={this.handleFileContact}>
                  Choose File
                </ButtonImport>
              </div>
            </div>
        )
        }
        </div>
        <div className={css.footer}>
              <button  {...btn} className={classNames (css.btnSecondary, css.footerBtns)} onClick={closePopup}>Cancel</button >
              <button  {...btn} className={classNames (css.btnPrimary, css.footerBtns)} onClick={this.handleSaveToGroup} disabled={!file}>Import</button>
        </div>
      </Modal>
    );
  }
}

const Popup = connect(state => ({
  loading: selectLoading(state),
  groups: selectContactAssignableGroups(state),
}), {
  importContacts,
  openAddToGroup: AddToMarketingListModal.open,
})(ContactImport);

const registrationId = getPopupRegistration(Popup);
Popup.open = (...rest) => openPopup(registrationId, ...rest);
Popup.close = () => closePopup({ popup: registrationId });

export default Popup;
